module.exports = __webpack_public_path__ + "img/child-care.847ef275.png";